import React from "react";
import classes from "./PayslipNew.module.css";

function PayslipNew() {

  return (
    <div className={classes.body}>
        <div className={classes.payslip}>
            <div className={classes.payslipContent}>
                <div className={classes.sectionTitle}>
                    <h6>Member Information</h6>
                </div>
                <div className={classes.infoBox}>
                    <div className={classes.row}>
                        <div className={classes.col}>
                            <strong>Membership No</strong>
                            <p>COP000124</p>
                        </div>

                        <div className={classes.col}>
                            <strong>Name</strong>
                            <p>ODUNLAMI KAYODE</p>
                        </div>

                        <div className={classes.col}>
                            <strong>Department</strong>
                            <p>Finance</p>
                        </div>

                        <div className={classes.col}>
                            <strong>Payroll No</strong>
                            <p>PAY00124</p>
                        </div>
                    </div>
                </div>

                <div className={classes.sectionTitle}>
                    <h6>Deduction Breakdown</h6>
                </div>
                <table className={`table table-bordered ${classes.table}`}>
                    <thead>
                        <tr>
                            <th>Description</th>
                            <th>Amount (₦)</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>Monthly Savings Contribution</td>
                            <td>50,000</td>
                        </tr>
                        <tr>
                            <td>Personal Loan Repayment</td>
                            <td>30,000</td>
                        </tr>
                        <tr>
                            <td>Loan Interest</td>
                            <td>5,000</td>
                        </tr>
                        <tr>
                            <td>Share Capital Contribution</td>
                            <td>10,000</td>
                        </tr>
                        <tr>
                            <td>Emergency Fund</td>
                            <td>0</td>
                        </tr>
                    </tbody>
                    <tfoot>
                        <tr>
                        <th>Total Deduction</th>
                        <th>95,000</th>
                        </tr>
                    </tfoot>
                </table>
                <div className={classes.sectionTitle}>
                    <h6>Loan Summary</h6>
                </div>
                <table className={`table table-bordered ${classes.table}`}>
                    <thead>
                        <tr>
                            <th>Loan Product</th>
                            <td>Personal Loan</td>
                        </tr>
                        <tr>
                            <th>Original Amount</th>
                            <td>₦500,000</td>
                        </tr>
                        <tr>
                            <th>Outstanding Balance</th>
                            <td>₦285,000</td>
                        </tr>
                        <tr>
                            <th>Next Installment</th>
                            <td>31-Jul-2026</td>
                        </tr>
                    </thead>
                </table>
                <div className={classes.sectionTitle}>
                    <h6>Savings Summary</h6>
                </div>
                <table className={`table table-bordered ${classes.table}`}>
                    <thead>
                        <tr>
                            <th>Current Savings Balance</th>
                            <td>₦2,500,000</td>
                        </tr>
                        <tr>
                            <th>Total Contributions</th>
                            <td>₦3,850,000</td>
                        </tr>
                        <tr>
                            <th>Last Contribution Date</th>
                            <td>30-Jun-2026</td>
                        </tr>
                    </thead>
                </table>
            </div>
            <div className={classes.footer}>
                <p>
                    Generated by Cooperative Management System<br />
                    Printed on 25-Jun-2026 10:30 AM
                </p>
            </div>
        </div>
    </div>
  );
}

export default PayslipNew;
